// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"81034264","977":"89032cc6"}[chunkId] + ".chunk.js";
};